const isInternalPath = require('../../commons/lib/is-internal-path');

const PROPERTY_DESCRIPTION_LANGUAGES = window.gtxConstants.PROPERTY_DESCRIPTION_LANGUAGES;
const propertyDescriptionLanguagesStorage = sessionStorage.getItem(PROPERTY_DESCRIPTION_LANGUAGES);

if (!propertyDescriptionLanguagesStorage && isInternalPath()) {
    fetch('/api/lookup/properties/description-languages')
        .then((response) => response.json())
        .then((resJson) => {
            if (resJson?.status === 'success') {
                sessionStorage.setItem(PROPERTY_DESCRIPTION_LANGUAGES, JSON.stringify(resJson.data));
            } else {
                throw new Error('Failed to fetch languages map');
            }
        })
        .catch((error) => {
            console.error('Request failed:', error);
        });
}
